(() => {
  const bind = (scope = document) => scope.querySelectorAll('.ic-search[data-ic-predictive-url]').forEach(search => {
    if (search.dataset.icPredictiveBound) return;
    search.dataset.icPredictiveBound = 'true';
    const input = search.querySelector('input[type="search"]');
    const output = search.querySelector('[data-ic-predictive-results]');
    const defaults = search.querySelector('[data-ic-search-default]');
    if (!input || !output || !defaults) return;
    let timer, controller;
    input.setAttribute('aria-controls', output.id);
    const reset = () => { output.hidden = true; output.replaceChildren(); defaults.hidden = false; output.removeAttribute('aria-busy'); };
    input.addEventListener('input', () => {
      clearTimeout(timer); controller?.abort();
      const query = input.value.trim();
      if (query.length < 2) { reset(); return; }
      timer = setTimeout(async () => {
        controller = new AbortController();
        const request = controller;
        output.hidden = false; defaults.hidden = true; output.textContent = 'Searching…'; output.setAttribute('aria-busy', 'true');
        const url = new URL(search.dataset.icPredictiveUrl, location.origin);
        url.searchParams.set('q', query); url.searchParams.set('resources[type]', 'product'); url.searchParams.set('resources[limit]', '4'); url.searchParams.set('section_id', 'ic-aura-predictive-search');
        try {
          const response = await fetch(url, { signal: request.signal });
          if (!response.ok) throw new Error('Search unavailable');
          const html = await response.text();
          if (request.signal.aborted || query !== input.value.trim()) return;
          const content = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ic-predictive-content]');
          if (!content) throw new Error('Missing search results');
          output.replaceChildren(content); output.removeAttribute('aria-busy');
        } catch (error) { if (error.name !== 'AbortError') { reset(); } }
      }, 250);
    });
    search.addEventListener('toggle', () => { if (!search.open) { clearTimeout(timer); controller?.abort(); } });
  });
  bind(); document.addEventListener('shopify:section:load', event => bind(event.target));
})();
